module.exports = __webpack_public_path__ + "51a7af161c2b488b469421f2210b5636.png";